<template>
	<bsh-modal 
		titulo="Novo Pedido"
		tamanho="modal-lg"
		:name="name">
		<template v-slot:default>
	        <pedido-form
				:dados="dados"
				:name="name"
				method="create"
				:errors="errors">
			</pedido-form>
	    </template>
	    <template v-slot:footer>
        	<button 
				ref="btnRequest"
        		type="button" 
        		class="btn btn-primary" 
        		@click="create">
        		Salvar
        	</button>
        </template>
    </bsh-modal>
</template>

<script>
	import Pedido from "./../../models/Pedido.js";
	export default {
		data(){
			return {
				dados: new Pedido(),
				name: 'create_pedido',
				errors: []
			}
		}, 
		methods: {
			create(){
				this.$btnFunctions.disableToggle(this.$refs.btnRequest, true)
	            axios.post(this.$url+'/api/adm/pedidos/store', (this.dados))
	            .then(response => {
	            	$('#'+this.name).modal('hide')
	            	this.$bshMessage.show(response.data.message, response.data.type)
	              	this.dados = new Pedido()
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
	              	this.$router.push('/adm/pedidos/show/'+response.data.id)
	            })
	            .catch(error => {
					this.errors = error.response.data.errors
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
				});
        	},
		},
	}
</script>